
<template>
    <div class="recharge_wrap">
        <div class="red_top_bg">
            <div class="back_left" @click="$router.push('/user')"></div>
            <!-- <div class="big_tit">{{$t('shopd.setshopaddr')}}</div> -->
			<div class="introduce">
			    <div class="line left_line"></div>
			    <div class="tit">{{$t('shopd.setshopaddr')}}</div>
			    <div class="line right_line"></div>
			</div>
			<div class="award_tip">
				{{$t('d.addrtip')}}
			</div>
        </div>
        <div class="wrap_box warp1" v-if="addr">
			<div class="item">
			    <div class="ari_font">{{$t('account.bank')}}：</div>
				<template v-if="addr.id>0">
					<input type="text" v-model="addr.typename" readonly >
				</template>
				<template v-else>
					<van-dropdown-menu >
						<van-dropdown-item v-model="addr.type" :options="wallets" @change="onChange()"/>
					</van-dropdown-menu>
				</template>
			</div>
			<template v-if="addr.type==1">
				<div class="item">
					<div class="ari_font">{{$t('addr.bank')}}：</div>
					<input type="text" v-model="addr.bank" >
				</div>
				<div class="item">
					<div class="ari_font">{{$t('addr.zhiname')}}：</div>
					<input type="text" v-model="addr.zhiname" >
				</div>
				<div class="item">
					<div class="ari_font">{{$t('addr.zhihao')}}：</div>
					<input type="text" v-model="addr.zhihao" >
				</div>
				<div class="item">
					<div class="ari_font">{{$t('addr.zhonglei')}}：</div>
					<input type="text" v-model="addr.zhonglei" >
				</div>
				<div class="item">
					<div class="ari_font">{{$t('addr.account')}}：</div>
					<input type="text" v-model="addr.account" >
				</div>
				<div class="item">
					<div class="ari_font">{{$t('addr.mingyi')}}：</div>
					<input type="text" v-model="addr.mingyi" >
				</div>
				<div class="item">
					<div class="ari_font">{{$t('addr.qrcode')}}：</div>
					<van-uploader v-model="fileList" multiple :max-count="1" class="upload" :max-size="20 * 1024 * 1024" 
						@oversize="onOversize" :after-read="afterRead" :before-read="beforeRead">
					</van-uploader>
				</div>
			</template>
			<template v-if="addr.type==2">
				<div class="item">
				    <div class="ari_font">{{$t('invest_bank.bank')}}：</div>
				    <input type="text" v-model="addr.bank" >
				</div>
				<div class="item">
				    <div class="ari_font">{{$t('invest_bank.name')}}：</div>
				    <input type="text" v-model="addr.mingyi" >
				</div>
				<div class="item">
				    <div class="ari_font">{{$t('invest_bank.account')}}：</div>
				    <input type="text" v-model="addr.account" >
				</div>
			</template>	
			<template v-if="addr.type==8">
				<div class="item">
				    <div class="ari_font">Nombre：</div>
					<input type="text" v-model="addr.mingyi" >
				</div>
				<div class="item">
				    <div class="ari_font">Nombre del banco：</div>
				   <input type="text" v-model="addr.bank" >
				</div>
				<div class="item">
				    <div class="ari_font">Número de cuenta bancaria：</div>
				    <input type="text" v-model="addr.account" >
				</div>
			</template>	
			<template v-if="addr.type==3">
				<div class="item">
					<div class="ari_font">{{$t('addr.bank')}}：</div>
					<input type="text" v-model="addr.bank" >
				</div>
				<div class="item">
					<div class="ari_font">{{$t('addr.account')}}：</div>
					<input type="text" v-model="addr.account" >
				</div>
				<div class="item">
					<div class="ari_font">{{$t('addr.routingnumber')}}：</div>
					<input type="text" v-model="addr.zhiname" >
				</div>
				<div class="item">
					<div class="ari_font">{{$t('addr.beneficiaryaddress')}}：</div>
					<input type="text" v-model="addr.zhihao" >
				</div>
				<div class="item">
					<div class="ari_font">{{$t('addr.bankaddress')}}：</div>
					<input type="text" v-model="addr.mingyi" >
				</div>
				<div class="item">
					<div class="ari_font">{{$t('addr.postalcode')}}：</div>
					<input type="text" v-model="addr.zhonglei" >
				</div>
			</template>
			<template v-if="addr.type==4 || addr.type==5 || addr.type==6">
				<div class="item">
				    <div class="ari_font">{{$t('shopd.address')}}：</div>
				    <input type="text" v-model="addr.account" >
				</div>
			</template>	
				<template v-if="addr.type==7">
					<div class="item">
					    <div class="ari_font">{{$t('invest_bank.name')}}：</div>
					    <input type="text" v-model="addr.mingyi" >
					</div>
					<div class="item">
						<div class="ari_font">{{$t('addr.account')}}：</div>
						<input type="text" v-model="addr.account" >
					</div>
					<div class="item">
						<div class="ari_font">{{$t('addr.bank')}}：</div>
						<input type="text" v-model="addr.bank" >
					</div>
				</template>
          <!-- <div class="item" >
               <div  class="ari_font">{{$t('shopd.region')}}：</div>
               <input maxlength="6" max="999999" size="6" :type="newpasswordInp"  v-model="addr.region" @click="write_psd = true;">
			   <div class="eye_bi" @click="showNewsPwd" :class="newpasswordInp=='text'?'eye':''"></div>
           </div> -->
        </div>
        <div v-if="show" class="basic_btn" @click="submitBtn">{{$t('shopd.ok')}}</div>
		<van-popup  v-if="show" v-model="write_psd" closeable close-icon="close" round position="bottom">
			<div class="psw_box">
				<van-password-input :value="psd_val" :mask="true" :focused="showKeyboard" @focus="showKeyboard = true" />
				<div class="keybord_box">
					<div class="keybord">
						<div class="key_item" v-for="i in 9" @click="onInput(i)">
							<div class="key_inner">{{i}}</div>
						</div>
						<div class="key_item no_bg">
							<div class="key_inner"></div>
						</div>
						<div class="key_item" @click="onInput(0)">
							<div class="key_inner">0</div>
						</div>
						<div class="key_item no_bg x" @click="onDelete">
							<div class="key_inner">x</div>
						</div>
					</div>
				</div>
			</div>
		</van-popup>
	</div>

</template>

<script>
    import Vue from 'vue';
    import Fetch from '../../utils/fetch'
	import {
        DropdownMenu,
        DropdownItem,
		Toast,
		Popup,
		Uploader,
		PasswordInput,
		NumberKeyboard,
		Icon,
		ActionSheet
    } from 'vant';
	
    Vue.use(PasswordInput)
	.use(Uploader)
	.use(NumberKeyboard)
	.use(Toast)
	.use(Popup)
	.use(DropdownMenu)
	.use(DropdownItem)
	.use(Icon)
	.use(ActionSheet);
	import Api from "../../interface/index";
	import axios from 'axios';
    export default {
        name: "addr",
        data() {
            return {
				wallets: [{
					text: this.$t('addr.jpbank'),
					value: 1,
				},{
					text: this.$t('addr.kobank'),
					value: 2,
				},{
					text: "USA",
					value: 3,
				},{
					text: "USDT(TRC20)",
					value: 4,
				},{
					text: "ETH",
					value: 5,
				},{
					text: "BTC",
					value: 6,
				},{
					text: "Italiano",
					value: 7,
				},{
					text: "España",
					value: 8,
				}],
				fileList: [],
				show:true,
				showKeyboard: true,
				write_psd: false,
				psd_val: '',
				eye:1,
				submitType:1,
				newpasswordInp:'password',
                addr: {
                    type:3,
                    typename: 'USA',
                    bank: '',
                    account: '',
                    zhiname:'',
                    zhihao:'',
                    mingyi:'',
                    qr:'',
					zhonglei:''
                },
            };
        },
        created() {
            this.$parent.footer('user', false);
        },
        mounted() {
            this.start();
        },
        methods: {
			onChange(){
				this.addr.typename = this.wallets[this.addr.type-1]['text'];
			},
			onOversize(file) {
				this.$toast(this.$t('account.within2megabytes'));
			},
			beforeRead(file) {
				if (file.type !== 'image/jpeg' && file.type !== 'image/jpg' && file.type !== 'image/png') {
					this.$toast(this.$t('account.supportPicture'));
					return false;
				}
				return true;
			},
			afterRead(file) {
				let formData = new FormData();
				formData.append('language', this.$i18n.locale||"ja_jp");
				// formData.append('file', file.content);
				formData.append('file', file.file);
				// formData.append('id', this.$router.history.current.params.id);
				formData.append('token', localStorage.getItem('token'));
				Toast.loading({
					forbidClick: true,
					duration: 20000
				});
				
				axios.post(Api.commonUrl+"/api/index/bank_link_upload", formData).then((r) => {
					Toast.clear();
					if (r.data.code === 1) {
						this.addr.qr = r.data.data;
					} else {
						if (r.data.info) {
							this.$toast(r.data.info);
						} else {
							this.$toast(this.$t('account.uploadFail'));
						}
					}
				});
			},
			onInput(key) {
			    this.psd_val = (this.psd_val + key).slice(0, 6);
			    if (this.psd_val.length == 6) {
					this.write_psd = false;
					this.addr.region = this.psd_val;
			    }
			},
			onDelete() {
			    this.psd_val = this.psd_val.slice(0, this.psd_val.length - 1);
			},
			showNewsPwd() {
			    this.newpasswordInp == 'password' ? this.newpasswordInp = 'text' : this.newpasswordInp = 'password'
			},
			start(){
				Fetch('/user/my_addr').then(r=>{
					if(r.data ){
						this.addr = r.data;
						this.show = false;
						if(r.data.qr){
							this.fileList.push({ url: r.data.qr });
						}
					}
				})
			},
            submitBtn(){
				// if (!this.addr.name.replace(/\s/g, "")) {
				//     this.$notify("Name cannot be empty!");
				//     return;
				// }
				// if (!this.addr.tel.replace(/\s/g, "") && !this.addr.addr.replace(/\s/g, "")) {
				//     this.$notify(this.$t('invest_bank.accountin'));
				//     return;
				// }

				// if (!this.addr.curname.replace(/\s/g, "")) {
				//     this.$notify("Currency Name cannot be empty!");
				//     return;
				// }
				// if (!this.addr.region.replace(/\s/g, "")) {
				//     this.$notify("Withdrawal PIN cannot be empty!");
				//     return;
				// }
				// if (this.addr.region=='123456') {
				//     this.$notify("출금 비밀번호가 너무 간단해요");
				//     return;
				// }
                Fetch('/user/addr_add',{
                    ...this.addr
                }).then(r=>{
                    this.$toast({
                    	background: '#07c160',
                    	message: 'Added Success'
                    });
                    this.$router.push('/user');
                })
                
            }
        }
    };
</script>

<style lang="less" scoped>
    /deep/ .van-dropdown-menu {
        position: relative;
        z-index: 10;
        color: #CCCCCC;
    }

    /deep/ .van-dropdown-menu__bar {
        position: relative;
        z-index: 10;
        width: 211px;
        height: 34px;
        border: 1px solid #D9D9D9;
        border-radius: 4px;
        text-align: left;
    }

    /deep/ .van-dropdown-item--down {
        width: 211px;
        margin: 0 auto;
        z-index: 12;
        transform: translateX(4px);
    }

    /deep/ .van-dropdown-menu__item {
        justify-content: flex-start;
        color: #ccc;
        background-color: #fff;
    }

    /deep/ .van-dropdown-menu__title {
        width: 100%;
    }

    /deep/ .van-dropdown-menu__title::after {
        width: 13px;
        height: 22px;
        transform: none;
        background: url(../../assets/images/drop.png) no-repeat center center;
        background-size: 100% 100%;
        border: none;
        opacity: 1;
        margin-top: -11px;
        right: 10px;
    }

    /deep/ .van-cell {
        padding: 5px 8px;
    }

    /deep/ .van-cell__title {
        flex: 3;
        white-space: normal;
    }

    /deep/ .van-ellipsis {
        color: #000;
    }

    /deep/ .van-dropdown-item__option {
        color: #ccc;
        border: 1px solid #D9D9D9;
        border-bottom: none;
        border-radius: 4px;
    }

    /deep/ .van-dropdown-item__option:last-child {
        border-bottom: 1px solid #D9D9D9;
    }

    /deep/ .van-dropdown-item__option--active.van-dropdown-item__option {
        color: #000;

        .van-dropdown-item__icon {
            color: #E96259;
        }
    }

    .rela {
        position: relative;
        z-index: 11;
    }

    .warp1 {
        margin:3vw;

        .item {
            min-height: 50px;
            padding: 10px;
            font-size: 14px;
            display: flex;
            justify-content: flex-start;
            align-items: center;
            border-bottom: 1px solid #ECECEC;

            &:last-child {
                border-bottom: none;
            }

            input {
                line-height: 14px;
				width: 70vw;
            }
        }
    }

    .ari_font {
        word-break: keep-all;
        white-space: nowrap;
        height: 20px;
        font-size: 14px;
        font-weight: 600;
        color: rgba(0,0,0,.8);
        line-height: 20px;
    }

    .basic_btn {
        margin: 5vh auto 0 auto;
    }
	.red_top_bg {
		height: auto;
		padding-bottom: 20px;
		.big_tit {
			position: absolute;
		}
		.back_right{
			position: absolute;
			top: 3px;
			right: 3px;
			img{
				height: 35px;
				margin: 5px;
			}
		}
		.introduce {
		    height: 25px;
		    display: flex;
		    justify-content: center;
		    align-items: center;
		    font-size: 18px;
		    line-height: 25px;
		    color: #FFFFFF;
		    margin-top: 20px;
		
		    .line {
		        width: 36px;
		        height: 10px;
		    }
		
		    .tit {
		        margin: 0 12px;
		        font-weight: bold;
		    }
		
		    .left_line {
		        background: url(../images/user/left_icon.png) no-repeat center center;
		        background-size: 100% 100%;
		    }
		
		    .right_line {
		        background: url(../images/user/right_icon.png) no-repeat center center;
		        background-size: 100% 100%;
		    }
		}
		.award_tip {
		    font-size: 14px;
		    line-height: 25px;
		    color: rgba(255, 255, 255, 0.8);
		    text-align: center;
		    margin: 3px auto 0 auto;
			padding: 5px 25px;
		}
	}
	/deep/ .van-password-input {
	    margin: 50px 28px 0 28px;
	}
	
	/deep/ .van-hairline--left::after {
	    border: 1px solid #ECECEC;
	}
	
	.van-password-input .van-password-input__security::after {
	    border-radius: 0;
	}
	
	.keybord_box {
	    height: 250px;
	    background-color: #F0F0F0;
	    margin-top: 35px;
	    padding: 24px 12px 0 12px;
	
	    .keybord {
	        width: 361px;
	        margin: 24px auto 0 atuo;
	        display: flex;
	        justify-content: space-between;
	        flex-wrap: wrap;
	        text-align: center;
	
	        .key_item {
	            width: 115px;
	            height: 44px;
	            line-height: 44px;
	            font-size: 18px;
	            font-weight: bold;
	            margin-bottom: 6px;
	            background: rgba(255, 255, 255, 1);
	            border-radius: 3px;
	
	            &.no_bg {
	                background: none;
	            }
	
	            &.x {
	                color: #757880;
	                font-weight: bold;
	            }
	        }
	    }
	}
	.eye_bi {
	    width: 21px;
	    height: 25px;
	    background: url(../images/user/eye2.png) no-repeat center center;
	    background-size: 100% auto;
	
	    &.eye {
	        background: url(../images/user/eye1.png) no-repeat center center;
	        background-size: 100% auto;
	    }
	}
	/deep/ .van-overlay{
		background-color: unset;
	}
	/deep/.van-dropdown-item__option{
		color: #757880;
	}
</style>
